import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0ee22e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "details-section" }
const _hoisted_2 = { class: "label-group" }
const _hoisted_3 = { class: "product-title" }
const _hoisted_4 = { class: "gray-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "short-divider" }, null, -1))
const _hoisted_6 = {
  class: "price-box",
  key: "singlePrice"
}
const _hoisted_7 = { class: "new-price" }
const _hoisted_8 = {
  key: 1,
  class: "info-phone"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Call for pricing ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ext. 1 ")
const _hoisted_12 = { class: "gray-block" }
const _hoisted_13 = {
  key: 2,
  class: "sticky-cart-header sticky-header"
}
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "sticky-img mr-4" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "product-action product-action-details" }
const _hoisted_18 = { class: "product-single-qty" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("View cart")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider mb-0 mt-0" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_quantity_input = _resolveComponent("v-quantity-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.product?.condition)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "product-label label-hot",
            style: _normalizeStyle(_ctx.conditionLabel(_ctx.product.condition))
          }, _toDisplayString(_ctx.product.condition.split('_').join(' ')), 5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.product?.product?.manufacturer?.name) + " " + _toDisplayString(_ctx.product?.product?.mpn), 1),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.product?.product?.mpn), 1),
    _hoisted_5,
    (_ctx.product?.sell_price)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, "$" + _toDisplayString(_ctx.product?.sell_price.toFixed(2)), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", null, [
            _hoisted_9,
            _createElementVNode("a", {
              href: `tel:${_ctx.CONTACT_PHONE_NUMBER}`,
              class: "phone"
            }, _toDisplayString(_ctx.CONTACT_PHONE_NUMBER), 9, _hoisted_10),
            _hoisted_11
          ])
        ])),
    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.product?.unlimited_quantity ? 'Unlimited available' : `${_ctx.product?.quantity} available`), 1),
    (_ctx.product?.sell_price)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: _ctx.product?.images[0]?.path,
                width: 50,
                height: 50,
                alt: "product"
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_quantity_input, {
                  onUpdateQty: _ctx.updateQty,
                  product: _ctx.product,
                  qty: 1,
                  onChangeQty: _ctx.changeQty,
                  totalAvailable: _ctx.totalAvailable
                }, null, 8, ["onUpdateQty", "product", "onChangeQty", "totalAvailable"])
              ]),
              _createElementVNode("button", {
                class: "btn btn-dark add-cart mr-5",
                title: "Add to Cart",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToCart && _ctx.addToCart(...args))),
                disabled: !_ctx.validQty
              }, " Add to Cart ", 8, _hoisted_19),
              _createVNode(_component_router_link, {
                to: { name: _ctx.CART },
                class: "btn btn-gray view-cart"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_21
  ]))
}